import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash'
import { computed, ref } from 'vue';
import TopMenuItem from './TopMenuItem.vue'
import { useI18n } from '@/hooks/useI18n';
import { IMenuItem } from '@/view_helper/mainMenu';
import { injectAppMenuItemClick } from '@/hooks/useApp';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopMenu',
  props: {
    menus: null
  },
  setup(__props: any) {

const props = __props as {
    menus: IMenuItem[]
}



const {
    $t,
} = useI18n()

const content = computed(() => {
    return _.flatMap(props.menus, item => {
        if (item.disabled) {
            return []
        }
        return [item]
    })
})

const collected = ref(false)

const collectTooltip = computed(() => {
    if (collected.value) {
        return $t('menu.expand')
    } else {
        return $t('menu.collect')
    }
})

const collectBtnKlass = computed(() => {
    return ['collect-btn', collected.value ? 'is-collected' : 'is-normal']
})

const onAppMenuItemClick = injectAppMenuItemClick()


return { __sfc: true,props, $t, content, collected, collectTooltip, collectBtnKlass, onAppMenuItemClick, TopMenuItem }
}

})